/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

/** Shared base class for a single shimmering skeleton block. */
export const SKELETON_BLOCK =
  'animate-pulse rounded-(--radius-md) bg-[var(--skeleton-base)]';

/**
 * Builds an array of the requested length for mapping skeleton placeholders.
 *
 * @param count Number of placeholder slots to create.
 * @returns A fixed-length array suitable for `.map`.
 */
export function skeletonSlots(count: number): number[] {
  return Array.from({ length: Math.max(count, 0) }, (_, index) => index);
}
